import React from 'react';
import PropTypes from 'prop-types'
import modalFoundation from '../../hoc/modalFoundation.js';

import './thankAlertModal.scss';

/**
 * Defines the id of the modal.
 * @type {string}
 */
const MODAL_ID = 'thank-alert-modal';

/**
 * Modal Options.
 *
 * @type {{closeOnClick: boolean}}
 */
const modalOptions = {
  closeOnClick: false,
};

/**
 * The thank you popup modal.
 */
export class ThankAlertModal extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Closes the modal.
   */
  closeModal = () => {
    location.reload();
    this.props.modalFoundation.hide();
  };

  /**
   * Renders the modal.
   *
   * @returns {object}
   */
  render() {
    return (
      <div id={MODAL_ID} className="reveal wgl-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h1>Thank you for confirming the information about your Look</h1>
            </div>
            <div className="modal-footer">
              <button type="button" className="button" onClick={this.closeModal}>Ok</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ThankAlertModal.propTypes = {
  // ModalFoundation HOC
  modalFoundation: PropTypes.shape({
    hide: PropTypes.func.isRequired,
  }),
};

export default modalFoundation(MODAL_ID, modalOptions)(
  ThankAlertModal
);



// WEBPACK FOOTER //
// ./src/components/modals/thankAlert/ThankAlertModal.js